import { Calendar } from 'antd';
import dayjs from 'dayjs';
import { FC, useEffect } from 'react';
import cn from 'classnames';
import styles from './style.module.css';
import { DateType } from './types';
import { ALL_DAY, MONTHS } from './constants';
import { setDayType } from './utils';

const DaysCalendar: FC = () => {
  useEffect(() => {
    for (let month = 0; month <= 11; month++) {
      var date = new Date(dayjs().year(), month, 1);
      while (date.getMonth() === month) {
        ALL_DAY.push({
          day: new Date(date).toLocaleDateString(),
          type: DateType.WorkDay,
        });
        date.setDate(date.getDate() + 1);
      }
    }
  }, []);

  const renderDays = (date: dayjs.Dayjs, month: number) => {
    if (date.month() === month) {
      let localDay = date.toDate().toLocaleDateString();

      let day = ALL_DAY.find((x) => x.day === localDay);
      switch (day?.type) {
        case DateType.WorkDay:
          return <div className={styles.workDay}>{date.date()}</div>;

        case DateType.Weekend:
          return <div className={styles.weekend}>{date.date()}</div>;

        case DateType.DayOff:
          return <div className={styles.dayOff}>{date.date()}</div>;
      }
    }
  };

  return (
    <div className={styles.daysCalendar}>
      <ul className={styles.statusList}>
        <li className={styles.statusListItem}>
          <div className={cn(styles.colorStatus, styles.colorStatusBlue)}></div>
          <p>- cиcтeмa не работает</p>
        </li>
        <li className={styles.statusListItem}>
          <div
            className={cn(styles.colorStatus, styles.colorStatusWhite)}
          ></div>
          <p>- полный рабочий день</p>
        </li>
        <li className={styles.statusListItem}>
          <div className={cn(styles.colorStatus, styles.colorStatusGrey)}></div>
          <p>- сокращённый рабочий день</p>
        </li>
      </ul>
      <div className={styles.calendarContainer}>
        {Array.from(Array(12).keys()).map((i) => {
          return (
            <Calendar
              key={i}
              fullscreen={false}
              headerRender={() => {
                return <h4 className={styles.monthHeader}>{MONTHS[i]}</h4>;
              }}
              value={dayjs().month(i)}
              dateFullCellRender={(date) => renderDays(date, i)}
              onSelect={(date) => {
                setDayType(date);
              }}
              disabledDate={(date) => {
                if (date.month() === i) {
                  return false;
                } else return true;
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DaysCalendar;
